import { useEffect } from 'react';
import { useEventContext } from '../../../contexts/EventContext';
import { useEventDetails } from '../../../../hooks/useEventDetails';

/**
 * V1 Event Expo Page - FROZEN
 *
 * This component displays expo for V1 events only.
 * It is a simplified placeholder that redirects to the actual V1 expo page.
 * 
 * DO NOT add V2 features to this component.
 * This component will be removed after V1 sunset.
 */
export const ExpoPageV1 = () => {
  const { eventSlug } = useEventContext();
  const { data: eventDetails } = useEventDetails(eventSlug);

  // Update page title
  useEffect(() => {
    if (eventDetails) {
      const expoName = eventDetails.eventOptions?.expoName || 'Expo';
      document.title = `${expoName} - ${eventDetails.name}`;
    }
  }, [eventDetails]);

  // V1 expo uses a different URL pattern - redirect to the actual V1 expo page
  useEffect(() => {
    window.location.href = `/${eventSlug}/expo`;
  }, [eventSlug]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        <p className="mt-2 text-gray-600">Redirecting to expo...</p>
      </div>
    </div>
  );
};